import { mergeMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../store/global-selectors';
import get from 'lodash.get';
import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';
import { shipstationConnect } from '../../../services/shipstation-connect/';
import { convertReadScaleResponse$ } from '../../shipstation-connect/ss-connect.observables';
import * as Actions from './seller.presets.actions';
import * as PresetsApi from './seller.presets.api';
import { getSingleOrMultiSelectionPresetObservables } from './seller-presets.helper';
import { ShipmentConfigurationService } from '../../../services/shipping-configuration-service';
import { editOrCreatePresetSubject } from '../../../containers/edit-preset-modal-container';

export const deletePresetEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.DELETE_PRESET_REQUEST),
    mergeMap((action) => {
      const presetId = get(action, 'presetId');
      return PresetsApi.deletePreset(presetId).pipe(
        map(() => {
          return Actions.deletePresetSuccess(presetId);
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};

export const createOrSavePresetEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.CREATE_OR_UPDATE_PRESET_REQUEST),
    mergeMap((action) => {
      const presetId = get(action, 'presetId');
      const preset = get(action, 'preset');

      return PresetsApi.createOrUpdatePreset(presetId, preset).pipe(
        map((payload) => {
          return Actions.createPresetSuccess(payload);
        }),
        catchError((error) => {
          const success = false;
          editOrCreatePresetSubject.next(success);
          return of(Actions.createPresetFailure(error));
        }),
      );
    }),
  );
};

export const hotkeyApplyPresetEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.HOTKEY_APPLY_PRESET_REQUEST),
    mergeMap((action) => {
      const state = getState();
      const { fulfillmentPlanIds = [] } = action;
      const isFedexHal = ShipmentConfigurationService.orderSelectionContainsHalService(state, fulfillmentPlanIds) || false;
      if (isFedexHal) {
        return EMPTY;
      }
      return getSingleOrMultiSelectionPresetObservables(action, getState);
    }),
  );
};

export const updatePresetHotkeysEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.CREATE_OR_UPDATE_PRESET_SUCCESS, Actions.DELETE_PRESET_SUCCESS),
    mergeMap(() => {
      const state = getState();
      const presets = Global.selectSellerPresets(state) || emptyArray;
      return of(Actions.updatePresetHotkeysSuccess(presets));
    }),
  );
};

export const closeEditModalEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.CREATE_OR_UPDATE_PRESET_SUCCESS),
    mergeMap(() => {
      const success = true;
      editOrCreatePresetSubject.next(success);
      return EMPTY;
    }),
  );
};

const requestIdToCallBack = {};
export const presetReadScaleRequestEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.PRESET_READ_FROM_SCALE),
    mergeMap(({ scale, requestId, callBack }) => {
      requestIdToCallBack[requestId] = callBack;
      shipstationConnect.readFromScale(scale, requestId);
      return convertReadScaleResponse$(action$, getState, scale.workstationId);
    }),
  );
};

export const callBackOnScaleRead = (action$) => {
  return action$.pipe(
    ofType(ConnectActions.READ_CONVERTED_SCALE_RESPONSE),
    mergeMap(({ requestId, weight, weightUnit }) => {
      const callBack = requestIdToCallBack[requestId];
      if (!callBack) {
        return EMPTY;
      }

      callBack(weight, weightUnit);
      delete requestIdToCallBack[requestId];
      return EMPTY;
    }),
  );
};
